module.exports = __webpack_public_path__ + "img/snake-1.49af1e9e.png";